// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3de8y","row":"row__3GWci","item":"item__3E8PD","fake":"fake__1GN5s"};